import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';

export interface GnrSupplier {
    _id: string;
    name: string;
    codeProC: string;
    area: string;
    email: string;
    phone?: string;
    crudStatus: number;
    updatedAt?: string;
    createdAt?: string;
    usageCount?: {
        total: number;
        gnrRequests: number;
    };
}

export interface GnrSupplierResponse {
    data: GnrSupplier;
    message: string;
}

export interface GnrSuppliersListResponse {
    data: GnrSupplier[];
    message: string;
}

export interface CreateGnrSupplierBody {
    name: string;
    codeProC: string;
    area: string;
    email: string;
    phone?: string;
    crudStatus?: number;
}

export const createGnrSupplier = async (data: CreateGnrSupplierBody): Promise<GnrSupplierResponse> => {
    try {
        const response: AxiosResponse<GnrSupplierResponse> = await apiClient.post('/gnr-suppliers', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface GetGnrSupplierQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllGnrSuppliers = async (queries?: GetGnrSupplierQueries): Promise<GnrSuppliersListResponse> => {
    try {
        const response: AxiosResponse<GnrSuppliersListResponse> = await apiClient.get('/gnr-suppliers', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const getGnrSupplierById = async (id: string): Promise<GnrSupplierResponse> => {
    try {
        const response: AxiosResponse<GnrSupplierResponse> = await apiClient.get(`/gnr-suppliers/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateGnrSupplierBody {
    name?: string;
    codeProC?: string;
    area?: string;
    email?: string;
    phone?: string;
    crudStatus?: number;
}

export const updateGnrSupplier = async (id: string, body: UpdateGnrSupplierBody): Promise<GnrSupplierResponse> => {
    try {
        const response: AxiosResponse<GnrSupplierResponse> = await apiClient.patch(`/gnr-suppliers/${id}`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const deleteGnrSupplier = async (id: string): Promise<GnrSupplierResponse> => {
    try {
        const response: AxiosResponse<GnrSupplierResponse> = await apiClient.delete(`/gnr-suppliers/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
